// extracted by mini-css-extract-plugin
module.exports = {"GeneralInfo__tooltip":"GeneralInfo_GeneralInfo__tooltip__2x0FR"};